(() => {
  angular
    .module('app')
    .component('hostCorporatesSupportPlansCreateEditBasicsHospitalizationComponent', {
      templateUrl: require('./hospitalization.component.html'),
      controller: BasicsHospitalizationComponentController,
      controllerAs: 'vm',
      bindings: {
        supportPlan: '<',
        availableDependentTypes: '<',
        dependentsCovered: '=',
      },
    });

  BasicsHospitalizationComponentController.$inject = ['$sce'];

  function BasicsHospitalizationComponentController($sce) {
    const vm = this;
    vm.daysText = App.localize('Days');
    vm.yearsText = App.localize('Year');
    vm.deliveryText = App.localize('Delivery');
    vm.illnessInfo = App.localize('SpecifiedIllnessTooltip');

    // Feature flag.

    vm.hasHospitalizationWaitingPeriodEnhancement = abp.setting.getBoolean(
      'Hms.Feature.HospitalisationWaitingPeriodEnhancement'
    );

    vm.displaySafeHtml = displaySafeHtml;
    vm.toggleHospitalizationBasics = toggleHospitalizationBasics;
    vm.toggleDependentsCovered = toggleDependentsCovered;
    vm.$onInit = init;

    function init() {
      vm.toggleHospitalizationBasics();
      vm.dependentModel = {};
      (vm.dependentsCovered || []).forEach((val) => {
        vm.dependentModel[val] = true;
      });
    }

    function displaySafeHtml(html) {
      return $sce.trustAsHtml(html);
    }

    function toggleHospitalizationBasics() {
      vm.minAccidentDays = vm.supportPlan.hospitalizationSetting.isAccidentAdmission === 1 ? 1 : 0;
      vm.minIllnessDays = vm.supportPlan.hospitalizationSetting.isIllnessAdmission === 1 ? 1 : 0;
      vm.minPreExistingDays = vm.supportPlan.hospitalizationSetting.isPreExisting === 1 ? 1 : 0;
      vm.minNonAccidentalIllnessDays =
        vm.supportPlan.hospitalizationSetting.isNonAccidentalIllness === 1 ? 1 : 0;
    }

    function toggleDependentsCovered(value) {
        const isChecked = vm.dependentModel[value];
        const idx = vm.dependentsCovered.indexOf(value);
      
        if (isChecked && idx === -1) {
          vm.dependentsCovered.push(value);
        } else if (!isChecked && idx > -1) {
          vm.dependentsCovered.splice(idx, 1);
        }
      }
  }
})();
